/*
 * @Description: 协定服务列表操作，使用的是之前的逻辑
 * @Date: 2021-11-08 14:45:26
 */
import { MessageBox, Message } from 'element-ui';

import { protocolService } from '@/api/ajax';
import { moneyComplete } from '@/tools/money';
import AspUpload from '../components/19/asp-upload.vue';
import createExtend from '@C/createExtend';

/**
 * @description: 修改当条任务金额
 * @param {*} row
 * @param {*} listFn
 * @return {void}
 */
export const editPrice = function(row, listFn) {
  MessageBox.prompt('请输入金额', '编辑金额', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputValidator(v) {
      if (v <= 0 || v >= 999999 || isNaN(v)) {
        return '请输入0~999999之间金额';
      }
      if ((v + '').includes('.') && (v + '').split('.')[1].length > 2) {
        return '最多输入两位小数';
      }
      return true;
    }
  })
    .then(async ({ value }) => {
      await protocolService.updateAgreeServiceAmount({
        taskRecordId: row.taskId,
        amount: moneyComplete(value)
      });
      Message({
        type: 'success',
        message: '金额修改成功 '
      });
      listFn && listFn();
    })
    .catch(() => {
      Message({
        type: 'info',
        message: '取消输入'
      });
    });
};

/**
 * @description: 上传文件
 * @param {object} project 项目信息
 * @param {object} row 当前数据
 * @param {function} listFn 获取调用列表方法
 * @return {void}
 */
export const aspUpload = function(project, row, listFn) {
  const { projectStructureType } = project;
  const userTypeStr = projectStructureType === 2 ? '个体' : '项目参与人';

  let alertStr = '';
  let showComponent = false;
  if (projectStructureType === 2) {
    //三级个体
    if (row.isCheckin === 1) {
      //已入驻
      showComponent = true;
    } else {
      //未入驻
      alertStr = `${userTypeStr}“${row.userName}”由于尚未入驻该项目，暂不能上传任务记录。请完成入驻后，再上传文件。`;
    }
  } else if (projectStructureType === 3) {
    //三级个人
    if (row.isTool == 1) {
      showComponent = true;
    } else {
      if (row.signingStatus !== 2) {
        alertStr = `${userTypeStr}“${
          row.userName
        }”由于尚未完成电子合约签约或未入驻该项目，暂不能上传任务记录。请完成${
          projectStructureType !== 2 ? '合约签署' : ''
        }后，再上传文件。`;
      } else {
        showComponent = true;
      }
    }
  } else {
    //四级
    if (row.signingStatus !== 2) {
      alertStr = `${userTypeStr}“${
        row.userName
      }”由于尚未完成电子合约签约或未入驻该项目，暂不能上传任务记录。请完成${
        projectStructureType !== 2 ? '合约签署' : ''
      }后，再上传文件。`;
    } else {
      showComponent = true;
    }
  }
  if (alertStr) {
    MessageBox.alert(alertStr, '提示', {
      confirmButtonText: '确定'
    });
    return;
  }
  if (showComponent) {
    const cp = createExtend(AspUpload, {
      itemData: { ...project, ...row, id: row.id || row.taskId },
      folderName: row.folderName,
      listFn
    });
    cp.$on('close', function() {
      cp.remove();
    });
  }
};
